import { defineMessages } from 'react-intl';
import de from './translations/de.json';
import en from './translations/en.json';
import fr from './translations/fr.json';
import nl from './translations/nl.json';
import pl from './translations/pl.json';
const componentTranslations = {
    en,
    'en-GB': {},
    'en-US': en,
    nl,
    'nl-BE': nl,
    'nl-NL': nl,
    pl,
    'pl-PL': pl,
    fr,
    'fr-FR': fr,
    de,
    'de-DE': de
};
export const componentMessages = defineMessages({
    // Checklist Autocomplete
    'autocomplete.checklist.loading': {
        defaultMessage: 'Searching checklists...',
        id: 'autocomplete.checklist.loading'
    },
    'autocomplete.checklist.noResults': {
        defaultMessage: 'No checklists found',
        id: 'autocomplete.checklist.noResults'
    },
    'autocomplete.checklist.placeholder': {
        defaultMessage: 'Search for a checklist',
        id: 'autocomplete.checklist.placeholder'
    },
    'autocomplete.checklist.label': {
        defaultMessage: 'Checklist',
        id: 'autocomplete.checklist.label'
    },
    // Basic Autocomplete
    'autocomplete.loading': {
        defaultMessage: 'Loading...',
        id: 'autcomplete.loading'
    },
    'autocomplete.noResults': {
        defaultMessage: 'No results',
        id: 'autocomplete.noResults'
    },
    'autocomplete.tooManyResults': {
        defaultMessage: 'Too many results. Please narrow search.',
        id: 'autocomplete.tooManyResults'
    },
    'autocomplete.placeholder': {
        defaultMessage: 'Search for',
        id: 'autocomplete.placeholder'
    },
    'autocomplete.label': {
        defaultMessage: 'Search',
        id: 'autocomplete.label'
    },
    // Location Autocomplete
    'autocomplete.location.loading': {
        defaultMessage: 'Searching locations...',
        id: 'autocomplete.location.loading'
    },
    'autocomplete.location.noResults': {
        defaultMessage: 'No locations found',
        id: 'autocomplete.location.noResults'
    },
    'autocomplete.location.tooManyResults': {
        defaultMessage: 'Too many results. Please narrow search.',
        id: 'autocomplete.location.tooManyResults'
    },
    'autocomplete.location.placeholder': {
        defaultMessage: 'Search for location',
        id: 'autocomplete.location.placeholder'
    },
    'autocomplete.location.label': {
        defaultMessage: 'Location',
        id: 'autocomplete.location.label'
    },
    // User Permissions
    'user.features.error': {
        defaultMessage: 'Sorry, unable to verify the features for your account, please try again later',
        id: 'user.features.error'
    },
    'user.features.incorrectFeatures': {
        defaultMessage: 'Sorry, you do not have the required privileges to see this page',
        id: 'user.features.incorrectFeatures'
    },
    'user.me.incorrectRole': {
        defaultMessage: 'Sorry, you do not have the required privileges to see this page',
        id: 'user.me.incorrectRole'
    },
    'user.features.incorrectModule': {
        defaultMessage: 'Sorry, you do not have the required privileges to see this page',
        id: 'user.features.incorrectModule'
    },
    'user.me.error': {
        defaultMessage: 'Sorry, unable to verify your account details, please try again later',
        id: 'user.me.error'
    },
    // Help Tooltip
    'help.toolTip.title': {
        defaultMessage: 'Help',
        id: 'help.title'
    }
});
export default componentTranslations;
//# sourceMappingURL=component-translations.js.map